import { COUNTRIES } from '@config/constants'
import { ROUTES } from '@router'

export const E_WASTE_LINK = {
  [COUNTRIES.FR]: {
    name: ROUTES.CMS.ARTICLE,
    params: {
      category: 'events',
      pageName: 'the-impact-of-e-waste',
    },
  },
  [COUNTRIES.DE]: {
    name: ROUTES.CMS.ARTICLE,
    params: {
      category: 'events',
      pageName: 'the-impact-of-e-waste',
    },
  },
  [COUNTRIES.GB]: {
    name: ROUTES.CMS.ARTICLE,
    params: {
      category: 'iphone',
      pageName: 'refurbished-smartphones',
    },
  },
  [COUNTRIES.US]: {
    name: ROUTES.CMS.ARTICLE,
    params: {
      category: 'iphone',
      pageName: 'refurbished-smartphones',
    },
  },
}
